import { DESIGN_VERSION_FOR_CUSTOMER, DEFAULT_VALUES } from 'app/config/urlParams.config';

const getDesignVersion = (customer: string | undefined): DesignVersion => {
  if (customer) {
    const designVersion = DESIGN_VERSION_FOR_CUSTOMER[customer];

    if (designVersion) {
      return designVersion;
    }
  }
  return DEFAULT_VALUES.designVersion;
};

const getThemeName = <T extends Pick<UrlParams, 'user'>>(params: T): string =>
  params.user ?? DEFAULT_VALUES.theme;

const getTheme = (theme: string, themes: Themes): WidgetTheme => {
  const usedThemed = theme && themes[theme] ? theme : DEFAULT_VALUES.theme;
  return themes[usedThemed];
};

const applyVariable = (name: string, value: string) => {
  document.documentElement.style.setProperty(`--${name}`, value);
};

const applyTheme = (themeName: string, theme: WidgetTheme) => {
  if (!document.documentElement.classList.contains(themeName)) {
    document.documentElement.classList.add(themeName);
  }

  Object.entries(theme).forEach(([name, value]) => {
    // `design_*` keys are optional — only the themes on the `grad` design version define them.
    if (value !== undefined) {
      applyVariable(name, value);
    }
  });
};

export { getDesignVersion, getThemeName, getTheme, applyTheme };
